/*jshint esversion: 6 */

/*! webmd.adsCookie */

import cookie from 'webmd-cookie';

export let get;
export let set;
export let remove;
export let deleteCookie;

if (typeof window !== 'undefined') {
  /**
   *
   */
  let config = {
    'perm': {name: 'ads_perm', expire: 365 },
    'sess': {name: 'ads_sess', expire: null }
  };

  /**
   *
   */
  let baseDomain = location.hostname.replace(/.*(\.[^.]+\.[^.]+)$/, '$1');

  /**
   * @param String
   * @returns Object
   */
  get = function(type) {
    let j = cookie(config[type] ? config[type].name : '');
    return j === null ? {} : JSON.parse(j);
  };

  /**
   *
   */
  deleteCookie = function (type) {
    return cookie(config[type].name, '', {domain: baseDomain, expires:-1});
  };

  /**
   * @example
   * set({type:'sess', prefix:'p', value:'123CTL', count:'123'});
   */
  set = function(o) {

    let currentCookie = get(o.type);

    // check to see if that prefix already exists
    if (!currentCookie[o.prefix]) { 
      currentCookie[o.prefix] = {};
    }

    // set the object value to the string delimiter that Steve needs to filter on
    currentCookie[o.prefix][o.value] = o.prefix + o.value + 'x';

    // if there is a count, add that as well
    if (o.count) { 
      currentCookie[o.prefix][o.value] = currentCookie[o.prefix][o.value].split('x')[0] + '_' + o.count + 'x';
    }

    if (o.type == 'sess') {
      return cookie(config[o.type].name, JSON.stringify(currentCookie), { domain:baseDomain });
    } else {
      return cookie(config[o.type].name, JSON.stringify(currentCookie), {domain:baseDomain, expires: config[o.type].expire});
    }
  };

  /**
   * @example
   * remove({type:'sess', prefix:'p', value:'123CTL'});
   */
  remove = function(o) {

    let currentCookie = get(o.type);

    // if you forgot to include prefix, leave
    if (!o.prefix) {
      return;
    }

    // check to see if that prefix already exists
    if (!currentCookie[o.prefix]) {
      return;
    }

    // check to see if you provided a value to delete. If no, delete whole prefix, otherwise delete the value
    if (!o.value) {
      delete currentCookie[o.prefix];
    } else {
      if (!currentCookie[o.prefix][o.value]) {
        return;
      } else {
        delete currentCookie[o.prefix][o.value];
      }
    }

    return cookie(config[o.type].name, JSON.stringify(currentCookie), {domain: baseDomain, expires: config[o.type].expire});
  };

  // attach adsCookie object to window
  window.webmd = window.webmd || {};
  window.webmd.adsCookie = {
    get,
    set,
    remove,
    deleteCookie
  };
}